// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M23 2H1V18H23V2ZM15.9137 10.6356L11.9998 14.3848L8.08594 10.6356L9.46942 9.19136L10.9998 10.6573V6H12.9998V10.6573L14.5302 9.19136L15.9137 10.6356Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21 20H3V22H21V20Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-download-2-filled')
export default class Download2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'download-2-filled',
    }
  }
}
